"use client";

import { Open_Sans } from "next/font/google";
import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import {
  LINK_BUSINESS_INSURANCE_QUOTE,
  LINK_CAR_INSURANCE_QUOTE,
  LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE,
  LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE,
  LINK_HOME_INSURANCE_QUOTE,
  LINK_MOTOR_CYCLE_INSURANCE_QUOTE,
  LINK_TAXI_INSURANCE_QUOTE,
  LINK_VAN_INSURANCE_QUOTE,
  LINK_CONTACT_US
} from "@constants/page-links";

import carBanner from "../../../../public/car.png";

import styles from "./RedSlider.module.css";



// const slides = [

//   {

//      title: "Apply for Car Insurance Quote",

//     tag: "Challenge us to beat your insurance premium",

//     btn1: "Get a quote",

//     btn2: "Contact Us",

//     url1: LINK_CAR_INSURANCE_QUOTE,

//     url2: LINK_CONTACT_US,

//   },

// ];


const slide = {
  title: "Apply for Car Insurance Quote",
  tag: "Challenge us to beat your insurance premium",
  btn1: "Get a quote",
  btn2: "Contact Us",
  url1: LINK_CAR_INSURANCE_QUOTE,
  url2: LINK_CONTACT_US
};



// --- Service Data ---
const serviceData = [
  {
    id: 1,
    imageSrc: "/1.png",
    title: "Car Insurance",
    alt: "Car Insurance",
    link: LINK_CAR_INSURANCE_QUOTE,
  },
  {
    id: 2,
    imageSrc: "/2.png",
    title: "Van Insurance",
    alt: "Van Insurance",
    link: LINK_VAN_INSURANCE_QUOTE,
  },
  {
    id: 3,
    imageSrc: "/3.png",
    title: "Motorcycle Insurance",
    alt: "Motorcycle Insurance",
    link: LINK_MOTOR_CYCLE_INSURANCE_QUOTE,
  },
  {
    id: 4,
    imageSrc: "/4.png",
    title: "Taxi Insurance",
    alt: "Taxi Insurance",
    link: LINK_TAXI_INSURANCE_QUOTE,
  },
  {
    id: 5,
    imageSrc: "/5.png",
    title: "Business Insurance",
    alt: "Business Insurance",
    link: LINK_BUSINESS_INSURANCE_QUOTE,
  },
  {
    id: 6,
    imageSrc: "/5.png",
    title: "Home Insurance",
    alt: "Home Insurance",
    link: LINK_HOME_INSURANCE_QUOTE,
  },
  {
    id: 7,
    imageSrc: "/6.png",
    title: "Fast Food Delivery Insurance",
    alt: "Fast Food Delivery Insurance",
    link: LINK_FAST_FOOD_DELIVERY_INSURANCE_QUOTE,
  },
  {
    id: 8,
    imageSrc: "/7.png",
    title: "Public/Employer Liability Insurance",
    alt: "Public/Employer Liability Insurance",
    link: LINK_EMPLOYER_LIABILITY_INSURANCE_QUOTE,
  },
];


export default function RedSlider() {

  const primarySlide = slide;



  return (

    <section className={styles.hero} aria-label="Insurance quotes hero">

      <div className={`container ${styles.container}`}>

        <div className={styles.row}>

          <div className={`${styles.col} ${styles.colCopy}`}>

            <div className="text-center text-md-start">

              <h1

                className={`display-6 fw-bold mb-3 text-uppercase ${styles.title}`}

              >

                {slide.title}

              </h1>

              <p className={`mb-4 ${styles.tagline}`}>{slide.tag}</p>

              <div

                className={`d-flex flex-wrap gap-3 justify-content-center justify-content-md-start ${styles.actions}`}

              >

                <Link

                  className="btn btn-light red-slider-btn bg-e02b20 text-white"

                  href={slide.url1}

                >

                  {slide.btn1}

                </Link>

                <Link

                  className="btn btn-light red-slider-btn bg-535353 text-white"

                  href={slide.url2}

                >

                  {slide.btn2}

                </Link>

              </div>

            </div>

          </div>



          <div className={`${styles.col} ${styles.colMedia}`}>

            <div className={styles.imageFrame}>

              <div style={{ maxWidth: "400px", width: "100%" }}>
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                loop={true}
                spaceBetween={15}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 1 }
                }}
                className="w-100"
              >
                {serviceData?.map((service) => (
                  <SwiperSlide key={service.id}>
                    <Link
                      href={service.link}
                      className="single-service d-block text-center text-decoration-none p-2 bg-white rounded shadow-sm h-100"
                    >
                      <Image
                        src={service.imageSrc}
                        alt={service.alt}
                        width={200}
                        height={200}
                        className="img-fluid"
                      />

                      <h6 className="mt-2 fw-bold text-dark" style={{fontSize: '20px', marginBottom: '15px'}}>
                        {service.title}
                      </h6>

                      <span className="btn btn-sm btn-gray mt-1">
                        Get a Quote
                      </span>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            </div>

          </div>

        </div>

      </div>

    </section>

  );

}